import { Dispatch, SetStateAction, createContext } from 'react'

interface IContextProps {
    setSettlementsInputs: Dispatch<SetStateAction<ISettlementsInputs>>
    settlementsInputs: ISettlementsInputs
    settlements: ISettlementsRecordsParsed
    loader: { GET_CARD_ACQUIRING_SETTLEMENTS: boolean | null }
}
export const Context = createContext({} as IContextProps)
